class BulkDataLogController extends AbstractController
	@register()
	@inject 'BulkDataLogRepository',
		'translate'
		'BACKEND_BULK_DATA_LOG_STATUS'
		'BACKEND_BULK_DATA_LOG_ACTION'
		'SEARCH_CONFIGURATION'

	initialize: ->
		@logs = []

		@filterDTO = new FilterDTO({
			searchConfiguration: @SEARCH_CONFIGURATION.bulk_data_log
			sortProperty: 'update_time'
			sortDirection: 'DESC'
			count: 0
		})

	search: ->
		query = @filterDTO.getQuery()

		@BulkDataLogRepository
			.getEntitiesWithCount query
			.then (response) =>
				@filterDTO.count = response.count
				@logs = response.data

	getAdvancedSearchValues: (filterKey) ->
		if filterKey == 'status'
			statuses = []

			for status of @BACKEND_BULK_DATA_LOG_STATUS
				statuses.push({
					id: status,
					name: @translate('general.bulk_data_log.status.' + status.toLowerCase())
				})

			return @BulkDataLogRepository.resolve(statuses)

		if filterKey == 'action'
			actions = []

			for action of @BACKEND_BULK_DATA_LOG_ACTION
				actions.push({
					id: action,
					name: @translate('general.bulk_data_log.action.' + action.toLowerCase())
				})

			return @BulkDataLogRepository.resolve(actions)
